export const state = () => ({
  eventData: null,
})

export const mutations = {
  SET_EVENT_DATA(state, data) {
    state.eventData = data
  },
  UPDATE_EVENT_DATA(state, payload) {
    if (!state.eventData) {
      state.eventData = {}
    }
    Object.assign(state.eventData, payload)
  },
}

export const actions = {
  setEventData({ commit }, data) {
    commit('SET_EVENT_DATA', data)
  },
}

export const namespaced = true
